export const styles = {
  sectionWidget: {
    width: '100%',
    cursor: 'pointer',
    alignItems: 'center',
  },
};
